import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CurrentUser } from 'app/services/currentUser.service';
import { Story } from '../interfaces/story';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ShowStoryService {
  private baseUrl = environment.API;

  constructor(private http: HttpClient,
              private currentUser: CurrentUser) {}

  load(data) {
    const url = `${this.baseUrl}/stories/${data.id}/`;
    let params = new HttpParams();
    if (data.access_token) {
      params = params.append('access_token', data.access_token);
    }
    if (data.share_token) {
      params = params.append('share_token', data.share_token);
    }
    return this.http.get(url, { params });
  }

  getStoryCover(storyId): Observable<string> {
    const url = `${this.baseUrl}/stories/${storyId}/`;
    return this.http.get<Story>(url).pipe(map(story => {
      return story.spreads.find(sp => sp.spread_type === 'frontcover').urls.thumbnail;
    }));
  }

  createShareLink(storyId) {
    const url = `${this.baseUrl}/shares/story/${storyId}/`;
    return this.http.post(url, null);
  }

  getEditLink(id) {
    const refreshToken = this.currentUser.getRefreshToken();
    if (environment.production) {
      return `${environment.editAlbumBaseUrl}story/${id}/?token=${refreshToken}`;
    } else {
      return `${environment.editAlbumBaseUrl}story/${id}/?e=dev&token=${refreshToken}`;
    }
  }
}
